module.exports = __webpack_public_path__ + "img/628.88569adc.jpg";